<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>

    <!--列表-->
    <el-table :data="matReceive" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading"
      @selection-change="selsChange" style="width: 100%" height="600" :border="true">
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column label="编号">
        <template slot-scope="scope">
          <el-link type="primary" @click="handleDetail(scope.row)">
            {{ scope.row.Code }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="ReceiveType" label="入库类型" :formatter="receiveTypeToStr"></el-table-column>
      <!-- <el-table-column prop="DepName" label="入库部门"></el-table-column> -->
      <el-table-column prop="WarehouseName" label="入库仓库"></el-table-column>
      <el-table-column prop="ReceiveTime" label="入库日期"></el-table-column>
      <el-table-column prop="PersonName" label="经手人"></el-table-column>
      <el-table-column prop="RBFlag" label="红蓝单" :formatter="rbFlag"></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-link v-if="canRed" type="danger" @click="() => {
              currentRow = scope.row;
              handleRed();
            }
            ">
            取消入库
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="pageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false"
      width="70%">
      <el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-col :span="8">
            <el-form-item label="入库类型" prop="ReceiveType">
              <el-select v-model="addForm.MatRecive.ReceiveType" placeholder="请选择类别">
                <el-option label="普通入库" :value="0"></el-option>
                <el-option label="期初入库" :value="100"></el-option>
                <el-option label="过磅入库" :value="200"></el-option>
                <el-option label="盘点入库" :value="300"></el-option>
                <el-option label="采购申请入库" :value="400"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="入库日期">
              <el-date-picker v-model="addForm.MatRecive.ReceiveTime" type="datetime" placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="入库人员" prop="PersonName">
              <el-input readonly v-model="addForm.MatRecive.PersonName">
                <template slot="append">
                  <el-button @click="opvisibleDialog = true" :loading="listLoading">
                    选择
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="仓库">
              <el-select v-model="addForm.MatRecive.WarehouseID" filterable @change="whChange">
                <el-option v-for="material in basedata.WarehouseList" :label="material.Name" :key="material.Id + '_wh'"
                  :value="material.Id" v-model="material.Id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="类别">
              <el-radio-group v-model="addForm.MatRecive.RBFlag">
                <el-radio :label="0">蓝字单</el-radio>
                <el-radio :label="1">红字单</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注">
              <el-input v-model="addForm.MatRecive.Remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="打印抬头">
          <el-input v-model="addForm.MatRecive.PrintTitle"></el-input>
        </el-form-item>
      </el-form>
      <!-- 详情 -->
      <el-form>
        <el-row :gutter="5" type="flex" justify="space-around" class="row-center">
          <el-col>物料信息</el-col>
          <el-col>规格</el-col>
          <el-col>编号</el-col>
          <el-col>单位</el-col>
          <el-col>账面数量</el-col>
          <el-col>账面单价</el-col>
          <el-col>账面金额</el-col>
          <el-col>数量</el-col>
          <el-col>单价</el-col>
          <el-col>金额</el-col>
          <el-col>备注</el-col>
          <el-col>操作</el-col>
        </el-row>
        <el-row :gutter="5" type="flex" justify="space-around" v-for="(item, index) in addForm.MatReciveSub" :key="index">
          <el-col>
            <el-form-item>
              <el-select v-model="item.MatID" filterable @change="matChange($event, index)">
                <el-option v-for="material in basedata.MaterialList" :label="material.Name" :key="material.Id + '_mat'"
                  :value="material.Id" v-model="material.Id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.MatGrade"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.MatCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input readonly v-model="item.UnitName">
                <template slot="append">
                  <el-button type="primary" @click="openUnitPage(index)" :loading="listLoading" class="pd-5">
                    选择
                  </el-button>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.PeriodQuantity" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.PeriodPrice" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.PeriodAmount" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.Quantity" @input="updateAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.Price" @input="updateAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.Amount" @input="updateAmount"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-input v-model="item.Remark"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item style="text-align: center">
              <el-button type="danger" @click="receiveSubRemoveRow(item.Id)">
                删除
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-button @click="receiveSubAddRow">新增行</el-button>
        </el-row>
      </el-form>
      <!-- 详情 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">
          提交
        </el-button>
      </div>
    </el-dialog>
    <!--详情-->
    <el-dialog title="新增" :visible.sync="isShowDetail" v-model="isShowDetail" :close-on-click-modal="false" width="70%">
      <table class="table-bordered" style="">
        <tr>
          <th>单据编号</th>
          <td>{{ DetailDm.MatRecive.Code }}</td>
          <th>入库日期</th>
          <td>{{ DetailDm.MatRecive.ReceiveTime }}</td>
        </tr>
        <tr>
          <th>仓库</th>
          <td>{{ DetailDm.MatRecive.WarehouseName }}</td>
          <th>类别</th>
          <td>{{ DetailDm.MatRecive.RBFlag == 0 ? "蓝字单" : "红字单" }}</td>
        </tr>
        <tr>
          <th>入库人员</th>
          <td>{{ DetailDm.MatRecive.PersonName }}</td>
          <th>备注</th>
          <td>{{ DetailDm.MatRecive.Remark }}</td>
        </tr>
      </table>
      <!--列表-->
      <el-table :data="DetailDm.MatReciveSub" highlight-current-row style="width: 100%">
        <el-table-column prop="MatName" label="物资名称"></el-table-column>
        <el-table-column prop="MatGrade" label="物资规格"></el-table-column>
        <el-table-column prop="MatCode" label="物资编码"></el-table-column>
        <el-table-column prop="UnitName" label="单位"></el-table-column>
        <el-table-column prop="PeriodQuantity" label="账面数量"></el-table-column>
        <el-table-column prop="PeriodPrice" label="账面单价"></el-table-column>
        <el-table-column prop="PeriodAmount" label="账面总价"></el-table-column>
        <el-table-column prop="Quantity" label="数量"></el-table-column>
        <el-table-column prop="Price" label="单价"></el-table-column>
        <el-table-column prop="Amount" label="总价"></el-table-column>
        <el-table-column prop="Remark" label="备注"></el-table-column>
      </el-table>
    </el-dialog>

    <TableDataDialog title="操作员选择" :visibleDialog="opvisibleDialog" :queryMethod="opqueryData" :columns="{
      Name: {
        label: '姓名',
      },
      Code: {
        label: '工号',
      },
      Remark: {
        label: '备注',
      },
      WorkStatus: {
        label: '在职状态',
        filter: (item) => {
          return item.WorkStatus == 0
            ? '实习'
            : item.WorkStatus == 1
              ? '试用'
              : item.WorkStatus == 2
                ? '正式'
                : item.WorkStatus == 3
                  ? '临时'
                  : item.WorkStatus == 4
                    ? '离职'
                    : '退休';
        },
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建时间',
      },
    }" @getDialogVisible="opsetVisible" @callback="opdialogCallback"></TableDataDialog>

    <TableDataDialog title="操作员选择" :visibleDialog="unitvisibleDialog" :queryMethod="unitqueryData" :columns="{
      Name: {
        label: '单位',
      },
      ConvertRate: {
        label: '换算系数',
      },
      Remark: {
        label: '备注',
      },
      CreateTime: {
        label: '创建时间',
        filter: (item) => {
          return formatDate(item.CreateTime);
        },
      },
      CreateUser: {
        label: '创建人',
      },
    }" @getDialogVisible="unitsetVisible" @callback="unitdialogCallback"></TableDataDialog>
  </section>
</template>

<script>
import * as api from "../../api/matReceive";
import { getMatStockDetail } from "../../api/matstock";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { getHrEmployeeListPage } from "../../api/hrEmployee";
import { getMatUnitListPage } from "../../api/matUnit";
import TableDataDialog from "../../components/TableDataDialog";
export default {
  components: {
    Toolbar,
    TableDataDialog,
  },
  data() {
    return {
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      matReceive: [],
      total: 0,
      page: 1,
      pageSize: 20,
      listLoading: false,
      sels: [], //列表选中列
      addDialogFormVisible: false,
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        // Name: [
        //   { required: true, message: "请输入施工部位名称", trigger: "blur" },
        // ],
      },
      //新增界面数据
      addForm: {
        MatRecive: {},
        MatReciveSub: [],
      },
      opvisibleDialog: false, //入库人员选择
      unitvisibleDialog: false, //入库单位选择
      unitIndex: 0,
      basedata: [],
      subIndex: 0, //子条目Id
      //详情数据
      DetailDm: {
        MatRecive: {},
        MatReciveSub: [],
      },
      isShowDetail: false,
    };
  },
  computed: {
    //计算属性,判断是否有权删除
    // canDelete() {
    //   let index = this.buttonList.findIndex((s) => s.name === "删除");
    //   return index > -1;
    // },
    canRed() {
      let index = this.buttonList.findIndex((s) => s.name === "红冲");
      return index > -1;
    },
  },
  methods: {
    // 显示窗口
    handleDetail(row) {
      let para = {
        id: row.Id,
      };
      api.getMatReceiveDetail(para).then((res) => {
        debugger;
        this.DetailDm = res.data.response;
      });
      this.isShowDetail = !this.isShowDetail;
    },
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.page = 1;
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getMatReceive();
    },
    //获取入库单列表
    getMatReceive() {
      let para = {
        page: this.page,
        key: this.filters.name,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getMatReceiveListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.matReceive = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.removeMatReceive(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getMatReceive();
          });
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        MatRecive: { RBFlag: 0 },
        MatReciveSub: [],
      };
    },
    //显示红冲页面
    handleRed() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      let para = {
        id: row.Id,
      };
      api.getMatReceiveDetail(para).then((res) => {
        this.addForm = res.data.response;
        this.addFormVisible = true;
        this.addForm.MatRecive.Code = "";
        this.addForm.MatRecive.RBFlag = 1;
      });
    },
    //执行新增
    addSubmit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.addLoading = true;

          let para = Object.assign({}, this.addForm);

          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }

          api
            .addMatReceive(para)
            .then((res) => {
              if (res && res.data && res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getMatReceive();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .finally(() => {
              this.addLoading = false;
            });
        }
      });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.page = 1;
      this.pageSize = size;
      this.getMatReceive();
    },
    opdialogCallback(data) {
      if (data.length > 0) {
        this.addForm.MatRecive.PersonID = data[0].Id;
        this.addForm.MatRecive.PersonName = data[0].Name;
      }
      this.opvisibleDialog = false;
    },
    opqueryData(params) {
      return getHrEmployeeListPage(params);
    },
    opsetVisible(val) {
      this.opvisibleDialog = val;
    },

    unitdialogCallback(data) {
      if (data.length > 0) {
        this.addForm.MatReciveSub[this.unitIndex].UnitID = data[0].Id;
        this.addForm.MatReciveSub[this.unitIndex].UnitName = data[0].Name;
        this.addForm.MatReciveSub[this.unitIndex].ConvertRate =
          data[0].ConvertRate;
        this.updateAmount();
      }
      this.unitvisibleDialog = false;
    },
    unitqueryData(params) {
      return getMatUnitListPage(params);
    },
    unitsetVisible(val) {
      this.unitvisibleDialog = val;
    },
    //获取基础数据
    getBaseData() {
      api.getMatReceiveBaseData().then((res) => {
        this.basedata = res.data.response;
      });
    },
    //获取物料规格
    matChange(Id, index) {
      var matItem = this.basedata.MaterialList.filter((x) => x.Id == Id)[0];
      this.addForm.MatReciveSub[index].MatGrade = matItem.MatGrade;
      this.addForm.MatReciveSub[index].MatName = matItem.Name;
      this.addForm.MatReciveSub[index].MatCode = matItem.Code;
      this.addForm.MatReciveSub[index].MatID = Id;
      var para = { matid: Id, warehouseID: this.addForm.MatRecive.WarehouseID };
      getMatStockDetail(para)
        .then((res) => {
          if (res && res.data && res.data.success && res.data.response) {
            this.addForm.MatReciveSub[index].PeriodPrice =
              res.data.response.Price;
            this.addForm.MatReciveSub[index].Price = res.data.response.Price;

            this.addForm.MatReciveSub[index].PeriodQuantity =
              res.data.response.Quantity;
            this.addForm.MatReciveSub[index].PeriodAmount =
              res.data.response.Amount;
          } else {
            this.addForm.MatReciveSub[index].PeriodPrice = 0;
            this.addForm.MatReciveSub[index].PeriodQuantity = 0;
            this.addForm.MatReciveSub[index].PeriodAmount = 0;
            this.addForm.MatReciveSub[index].Price = 0;
          }
        })
        .finally(() => { });
    },
    //获取仓库信息
    whChange(id) {
      var whItem = this.basedata.WarehouseList.filter((x) => x.Id == id)[0];
      this.addForm.MatRecive.WarehouseName = whItem.Name;
      this.addForm.MatRecive.WarehouseID = id;
    },
    //明细添加行
    receiveSubAddRow() {
      this.subIndex += 1;
      this.addForm.MatReciveSub.push({
        Id: this.subIndex,
        UnitID: "1",
        ConvertRate: 1000,
        Quantity: 0,
        Price: 0,
        Amount: 0,
        UnitName: "吨",
        PeriodPrice: 0,
        PeriodQuantity: 0,
        PeriodAmount: 0,
      });
    },
    //明细删除行
    receiveSubRemoveRow(id) {
      this.addForm.MatReciveSub.splice(
        this.addForm.MatReciveSub.findIndex((x) => x.Id === id),
        1
      );
    },
    openUnitPage(index) {
      this.unitIndex = index;
      this.unitvisibleDialog = true;
    },
    updateAmount() {
      this.addForm.MatReciveSub.map((e) => {
        e.Amount = e.Quantity * e.Price;
      });
    },
  },
  mounted() {
    this.getMatReceive();
    this.getBaseData();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
  filters: {},
};
</script>

<style lang="less" scoped></style>
